import { StoreObject } from '@apollo/client';
import { FloorPlanMarker } from '@graphql/gql/graphql';
import { hashDigest } from '@tools/hashDigest';
import objectHasProperty from '@tools/objectHasProperty';
import { apolloCacheLocaleVar, getCustomCacheKeyWithLocale } from './cache';

type FloorPlanMarkerRef = {
  __ref: string;
};

export function isFloorPlanMarkerArray(array: unknown): array is FloorPlanMarker[] {
  if (objectHasProperty(array, 'length')) {
    return array.length === 0 || objectHasProperty(array[0], 'id');
  }
  return false;
}

export function isFloorPlanMarkerRefArray(array: unknown): array is FloorPlanMarkerRef[] {
  if (objectHasProperty(array, 'length')) {
    return array.length === 0 || (array[0]?.__ref || '').startsWith('FloorPlanMarker:');
  }
  return false;
}

export function getCustomCacheKeyWithLocaleForFloorPlan(object: Readonly<StoreObject>): string {
  const _locale = apolloCacheLocaleVar();
  const { markers } = object;
  if (isFloorPlanMarkerArray(markers) || isFloorPlanMarkerRefArray(markers)) {
    const markersHash = hashDigest(markers.map(marker => marker.id || marker.__ref).join('|'));
    if (_locale) {
      return `${object.__typename}:${object.id}:${markersHash}:${_locale}`;
    }
    return `${object.__typename}:${object.id}:${markersHash}`;
  }
  return getCustomCacheKeyWithLocale(object);
}
